import Layout from '@/layout/layout'

const classificationRouter = {
    path: '/prerEchargeManagement',
    component: Layout,
    redirect: 'noRedirect',
    name: '回收商预充值管理',
    children: [
        {
            path: 'recyPreManagement',
            component: () => import('@/views/prerEchargeManagement/recyPreManagement/index'),
            name: '回收商预充值',
            meta: { title: '回收商预充值', noCache: true }
        }
    ]
}

export default classificationRouter